import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ApplicationState } from 'store/store';
import * as React from 'react';
import { getAllLocationTitles } from 'store/locations/locationsSlice';
import { Location } from 'components/location/models/LocationModel';

export const useLocationHelpers = () => {
    const [allLocations, setAllLocations] = React.useState<Location[]>([]);
    const dispatch = useAppDispatch();
    const { locationIdToLocationTitle, locations, isLoading } = useAppSelector(
        (state: ApplicationState) => state.locations
    );

    React.useEffect(() => {
        if (locationIdToLocationTitle.size === 0) {
            getAllLocationTitles(dispatch).then(locations => {
                if (locations) {
                    setAllLocations(locations);
                }
            });
        }
    }, [dispatch, locationIdToLocationTitle]);

    React.useEffect(() => {
        if (allLocations.length === 0 && locations) {
            setAllLocations(locations);
        }
    }, [allLocations.length, locations]);

    return { locations, allLocations, locationIdToLocationName: locationIdToLocationTitle, isLoading };
};
